import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import useExpress, { expressMutation } from '../../repository/react-query/useExpress';

const baseEndpoint = (type) => `/custom-fields/${type}`;

const getCustomFieldsQuery = ({ path, includeDeleted, type, queryParams }) => {
    const { where = {}, ...rest } = queryParams;
    const params = {
        where: {
            ...(includeDeleted ? { deleted_at: 'any' } : { deleted_at: { eq: null } }),
            ...where,
        },
        ...rest,
    };

    const endpoint = path ? `${baseEndpoint(type)}/${path}` : baseEndpoint(type);
    return useExpress({ endpoint, params });
};

export const useFetchCustomFields = ({ path, includeDeleted, type, queryParams = {}, ...useQueryOptions }) => {
    const queryFn = getCustomFieldsQuery({ path, includeDeleted, type, queryParams });
    const queryKey = ['custom-fields', { includeDeleted, ...queryParams }];
    return useQuery({ queryKey, queryFn, ...useQueryOptions });
};

export const useCreateCustomField = ({ key, type }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ data }) => {
            return expressMutation({
                method: 'POST',
                endpoint: `${baseEndpoint(type)}`,
                body: { ...data },
            });
        },
        onSuccess: () => {
            if (key) {
                queryClient.invalidateQueries({ queryKey: [key] });
            }
        },
    });
};

export const useUpdateCustomField = ({ key, type }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }) => {
            return expressMutation({
                method: 'PATCH',
                endpoint: `${baseEndpoint(type)}/${id}`,
                body: data,
            });
        },
        onSuccess: () => {
            if (key) {
                queryClient.invalidateQueries({ queryKey: [key] });
            }
        },
    });
};

export const useDeleteCustomField = ({ key, type }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id }) => {
            return expressMutation({
                method: 'DELETE',
                endpoint: `${baseEndpoint(type)}/${id}`,
            });
        },
        onSuccess: () => {
            if (key) {
                queryClient.invalidateQueries({ queryKey: [key] });
            }
        },
    });
};
